module.exports = __webpack_public_path__ + "static/media/grin.295b12ab.svg";